<template>
  <div class="home">
    <section class="hero is-transparent is-medium has-text-centered container">
      <div class="hero-body">
        <p class="title">
          All-in-one Corporate Secure Access Solution.
        </p>
        <p class="subtitle mt-3">
          Cyberfox Guard is a suite of aplications and extensions dedicated to make your company accounts access more secure.
        </p>
        <!-- showModal('install') -->
        <b-button @click="showModal('contact')" class="mt-5 mr-2" size="is-medium" type="is-primary">Contact Sales</b-button>
        <b-button @click="showModal('install')" class="mt-5" size="is-medium" type="is-success">Downloads</b-button>
      </div>
    </section>

    <section class="section is-medium widgets has-text-centered">
      <div class="container">
        <div class="title">
          Tools and Widgets
        </div>
        <div class="subtitle">
          Made to improve and ease your daily experience.
        </div>
        <div class="columns mt-6">
          <div class="column">
            <div class="box-black">
              <b-icon class="icon-first" icon="clipboard-list-check"></b-icon>
              <p class="box-title mt-2">One Click Access</p>
              <p class=" mt-2">Enable or disabple access in 1 Click</p>
            </div>
          </div>
          <div class="column">
            <div class="box-black">
              <b-icon class="icon-first" icon="note-sticky"></b-icon>
              <p class="box-title mt-2">Contacts</p>
              <p class=" mt-2">Easy to use and always at your disposal</p>
            </div>
          </div>
          <div class="column">
            <div class="box-black">
              <b-icon class="icon-first" icon="calendar-alt"></b-icon>
              <p class="box-title mt-2">2FA</p>
              <p class=" mt-2">Included Two Factor Authentification</p>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="box-black">
              <b-icon class="icon-second" icon="list-timeline"></b-icon>
              <p class="box-title mt-2">Links List</p>
              <p class=" mt-2">The easy way to store your links</p>
            </div>
          </div>
          <div class="column">
            <div class="box-black">
              <b-icon class="icon-second" icon="cloud"></b-icon>
              <p class="box-title mt-2">iOS and Android</p>
              <p class="mt-2">iOS and Android with all the required features</p>
            </div>
          </div>
          <div class="column">
            <div class="box-black">
              <b-icon class="icon-second" icon="clock"></b-icon>
              <p class="box-title mt-2">Clock</p>
              <p class="mt-2">World clocks, time to go international</p>
            </div>
          </div>
        </div>
        <div class="subtitle">
          and more...
        </div>
      </div>
    </section>

    <section id="testimonials" class="section is-medium testimonials has-text-centered">
      <div class="container">
        <div class="title">
          What People are saying
        </div>
        <div class="subtitle">
          People around the internet love using Cyberfox Guard.
        </div>
        <div class="columns mt-6">
          <div class="column">
            <div class="box-black">
              <b-icon class="icon-white" icon="twitter"></b-icon>
              <p class="mt-2">Best Extension ever! Have been using it for several months. Couldn't do without it now.</p>
            </div>
          </div>
          <div class="column">
            <div class="box-black">
              <b-icon class="icon-white" icon="firefox"></b-icon>
              <p class=" mt-2">Great page to keep your main websites handy. It's way better than searching through bookmarks!</p>
            </div>
          </div>
          <div class="column">
            <div class="box-black">
              <b-icon class="icon-white" icon="chrome"></b-icon>
              <p class=" mt-2">Excellent add-on for bookmarks and speed dialing. Indeed a very handy tool!</p>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="box-black">
              <b-icon class="icon-white" icon="firefox"></b-icon>
              <p class=" mt-2">Awesome app ever since it became available I've always used it on all my pc's it's the best at least it works for me. Its my number one go to home page and browser.</p>
            </div>
          </div>
          <div class="column">
            <div class="box-black">
              <b-icon class="icon-white" icon="edge"></b-icon>
              <p class="mt-2">Absolutely love this, my favorite pages all in one place which makes it easy to perform tasks! Great job guys, I love it!</p>
            </div>
          </div>
          <div class="column">
            <div class="box-black">
              <b-icon class="icon-white" icon="telegram"></b-icon>
              <p class="mt-2">This is a great application. I find it much simpler than organizing bookmarks.</p>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="box-black">
              <b-icon class="icon-white" icon="chrome"></b-icon>
              <p class=" mt-2">Enjoy the app, easy, attractive and a pleasure to use. Simple, does what it says.</p>
            </div>
          </div>
          <div class="column">
            <div class="box-black">
              <b-icon class="icon-white" icon="facebook"></b-icon>
              <p class="mt-2">It's an awesome software. Just love it.</p>
            </div>
          </div>
          <div class="column">
            <div class="box-black">
              <b-icon class="icon-white" icon="twitter"></b-icon>
              <p class="mt-2">Great organizational tool for teachers!</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="faq" class="section is-medium faq has-text-centered">
      <div class="container">
        <div class="title">
          Frequently Asked Questions
        </div>
        <div class="subtitle">
          You have questions, we have answers!
        </div>

        <div class="has-text-left has-text-white">
          <div class="columns mt-6">
            <div class="column is-one-third has-text-weight-bold">
              What browsers are supported by Cyberfox Guard?
            </div>
            <div class="column">
              Cyberfox Guard supports Custom build Chrome for security.<br/>
              Please feel free to contact us for support.
            </div>
          </div>
          <div class="columns mt-6">
            <div class="column is-one-third has-text-weight-bold">
              Do you collect my personal data? 
            </div>
            <div class="column">
              By default the extension doesen't collect any personal data. Your data will be encrypted before stored on our servers.
            </div>
          </div>
          <div class="columns mt-6">
            <div class="column is-one-third has-text-weight-bold">
              How many accounts I can add to this platform? 
            </div>
            <div class="column">
              There is no limit on how many accounts and passwords you can store and share with your co-workers using CyberFox Guard.
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'HomeView',
  methods: {
    showModal(modal) {
      console.log("showing modal");
      this.$store.commit("showModal", modal);
    },
    openOnline(){
      window.open("https://online.cyberfoxguard.com/", '_blank');
    },
  },
  mounted() {
    //this.$scrollTo('#faq', 500);
  },
  watch: {
    $route(to, from) {
      if (to.hash === "#faq") {
        this.$scrollTo('#faq', 500);
      }
      if (to.hash === "#testimonials") {
        this.$scrollTo('#testimonials', 500);
      }
      if (to.hash === "#overview") {
        this.$scrollTo('#overview', 500);
      }
    }
  },
  metaInfo() {
    return {
      title: "Cyberfox Guard - All-in-one Corporate Secure Access Solution.",
      htmlAttrs: {
        lang: "en"
      },
      meta: [
        {
          name: "description",
          content: "Cyberfox Guard is a suite of aplications and extensions dedicated to make your company accounts access more secure."
        },
        {
          property: "og:title",
          content: "Cyberfox Guard - All-in-one Corporate Secure Access Solution.",
          vmid: "og:title"
        },
        {
          property: "og:description",
          content: "Cyberfox Guard is a suite of aplications and extensions dedicated to make your company accounts access more secure.",
          vmid: "og:description"
        },
        {
          property: "og:image",
          content: "https://cyberfoxguard.com/img/share.png",
          vmid: "og:image"
        },
        {
          property: "og:url",
          content: "https://cyberfoxguard.com",
          vmid: "og:url"
        }
      ]
    };
  } //end meta
}
</script>
<style scoped>

.hero .title{
  /* text-transform: uppercase; */
  font-size: 3.2rem;
  font-weight: 900;
}

.hero .subtitle{
  color: rgb(173, 173, 173)!important;
  font-size: 1.5rem;
}

.widgets .title{
  /* text-transform: uppercase; */
  font-size: 2rem;
  font-weight: 900;
  color: #ffffff;
}

.widgets .subtitle{
  color: rgb(173, 173, 173)!important;
  font-size: 1.5rem;
}

.testimonials{
  background-color: #0b0c0c;
}

.testimonials .title{
  /* text-transform: uppercase; */
  font-size: 2rem;
  font-weight: 900;
  color: #ffffff;
}

.testimonials .subtitle{
  color: rgb(173, 173, 173)!important;
  font-size: 1.5rem;
}

.faq .title{
  /* text-transform: uppercase; */
  font-size: 2rem;
  font-weight: 900;
  color: #ffffff;
}

.faq .subtitle{
  color: rgb(173, 173, 173)!important;
  font-size: 1.5rem;
}

.video-section{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.video-box{
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
}
.video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.box-black {
  background-color: #1b1c1d;
  border-radius: 6px;
  box-shadow: 0 0.5em 1em -0.125em rgb(10 10 10 / 10%), 0 0px 0 1px rgb(10 10 10 / 2%);
  color: #fff;
  display: block;
  padding: 2.25rem;
  margin: 0 20px 0 20px;
  text-align: left;
}

.box-blue {
  background-color: #0068cf3a;
  border-radius: 6px;
  box-shadow: 0 0.5em 1em -0.125em rgb(10 10 10 / 10%), 0 0px 0 1px rgb(10 10 10 / 2%);
  color: #fff;
  display: block;
  padding: 2.25rem;
  margin: 0 20px 0 20px;
  text-align: left;
}

.box-orange {
  background-color: #cf6e003a;
  border-radius: 6px;
  box-shadow: 0 0.5em 1em -0.125em rgb(10 10 10 / 10%), 0 0px 0 1px rgb(10 10 10 / 2%);
  color: #fff;
  display: block;
  padding: 2.25rem;
  margin: 0 20px 0 20px;
  text-align: left;
}

.box-red {
  background-color: #cf00003a;
  border-radius: 6px;
  box-shadow: 0 0.5em 1em -0.125em rgb(10 10 10 / 10%), 0 0px 0 1px rgb(10 10 10 / 2%);
  color: #fff;
  display: block;
  padding: 2.25rem;
  margin: 0 20px 0 20px;
  text-align: left;
}

.box-green {
  background-color: #00cf003a;
  border-radius: 6px;
  box-shadow: 0 0.5em 1em -0.125em rgb(10 10 10 / 10%), 0 0px 0 1px rgb(10 10 10 / 2%);
  color: #fff;
  display: block;
  padding: 2.25rem;
  margin: 0 20px 0 20px;
  text-align: left;
}

.box-title {
  color: #fff;
  font-weight: bold;
  font-size: 1.2rem;
  text-transform: uppercase;
}

.icon-first{
  font-size: 3rem;
  color:#47F8CC;
}

.icon-second{
  font-size: 3rem;
  color:#25BADA;
}

.icon-third{
  font-size: 3rem;
  color:#0278E8;
}

.icon-white{
  font-size: 2rem;
  color:#ffffff;
}

</style>
